const axios = require("axios");
import TEXT from "@/data/newsletter-confirm.yml";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  data() {
    return {
      success: null,
      error: null,
      TEXT,
    };
  },
  mounted() {
    let id = this.$route.query.id;
    if (!id) {
      this.error = "Ungültige User ID";
    }
    axios
      .post("https://contact.frechdax-abdl.de/api/newsletter/subscribe", {
        id: id,
      })
      .then((response) => response.data)
      .then(() => {
        this.success = true;
      })
      .catch((error) => {
        console.error(error);
        this.error = error.response.data;
      });
  },
};
